import React from 'react'
import { Modal as ModalAntd, Space } from 'antd'
import Icon from '@ant-design/icons'
import { ReactComponent as IconFailSVG } from '../assets/svg/status_fail.svg'
import styled from 'styled-components'
import { StyledTypographyText } from '../styled-components/Typography'
import { ModalFuncProps } from 'antd/lib/modal'

const StyledTextModel = styled(StyledTypographyText)({
    fontWeight: 'bold',
    fontSize: 18,
})

const useModal = () => {
    const error = ({
        modalProps,
        errorMessage = 'ระบบเกิดข้อผิดพลาด กรุณาติดต่อเจ้าหน้าที่ 0 2357 3590',
    }: {
        errorMessage?: string
        modalProps?: ModalFuncProps
    }) => {
        ModalAntd.error({
            style: { textAlign: 'center', minHeight: 386 },
            width: 500,
            okButtonProps: {
                size: 'large',
                style: {
                    display: 'inline-block',
                    width: 272,
                    marginRight: 80,
                    marginLeft: 80,
                },
            },
            cancelButtonProps: {
                style: {
                    display: 'none',
                    width: 272,
                },
            },
            centered: true,
            icon: null,
            ...modalProps,
            content: (
                <>
                    <Space direction='vertical' size={'large'} align='center'>
                        <Icon css={{ fontSize: '5rem', color: 'red !important' }} component={IconFailSVG} />
                        <StyledTextModel>{errorMessage}</StyledTextModel>
                    </Space>
                </>
            ),
        })
    }

    return { error }
}

export default useModal
